import { render, staticRenderFns } from "./riskTestDc.vue?vue&type=template&id=2d6b8eb0&scoped=true"
import script from "./riskTestDc.vue?vue&type=script&lang=js"
export * from "./riskTestDc.vue?vue&type=script&lang=js"
import style0 from "./riskTestDc.vue?vue&type=style&index=0&id=2d6b8eb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6b8eb0",
  null
  
)

export default component.exports